import PropTypes from 'prop-types';
import { FIELD_IDS, FIELD_BY_ID } from '../ThematiqueTypes.js';
import {
  AUTEUR_QUALITE,
  INTEGER,
  TEXT,
  THESAURUS,
  TYPE_EVENEMENT,
} from './FieldTypes.js';
import ThesaurusField from './ThesaurusField.js';
import TextField from './TextField.js';
import IntegerField from './IntegerField.js';
import AuteurQualiteField from './AuteurQualiteField.js';
import TypeEvenementField from './TypeEvenementField.js';

const Field = ({ fieldId, name, defaultValue, onChange }) => {
  const fieldDefinition = FIELD_BY_ID[fieldId];

  const props = {
    fieldDefinition,
    name,
    defaultValue,
    onChange,
  };
  let field;
  switch (fieldDefinition.type) {
    case THESAURUS:
      field = <ThesaurusField {...props} />;
      break;
    case TEXT:
      field = <TextField {...props} />;
      break;
    case INTEGER:
      field = <IntegerField {...props} />;
      break;
    case AUTEUR_QUALITE:
      field = <AuteurQualiteField {...props} />;
      break;
    case TYPE_EVENEMENT:
      field = <TypeEvenementField {...props} />;
      break;
    default:
      throw new Error(
        `Type du champ ${fieldId} inconnu : ${fieldDefinition.type}`,
      );
  }

  return <div className="critere-field">{field}</div>;
};
Field.propTypes = {
  fieldId: PropTypes.oneOf(FIELD_IDS).isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    operateur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default Field;
